import star from '~/assets/icons/four_final_star.svg';
import { CollectionImage } from '~/components/collections';
import { ClothesImage } from '~/components/collections/ClothesImage';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { isClothesItem, ParseRewardValueTypeMap, RewardType } from '~/shared';
import cardSoft from '../../assets/images/cases/card_soft.png';
import {
	StyledBg,
	StyledButtonContainer,
	StyledContainer,
	StyledExpContainer,
	StyledImageContainer,
	StyledPoint,
	StyledTitle,
} from './CaseFeedItem.styled';

const CaseFeedItem = ({
	color,
	title,
	rewardId,
	rewardImageId,
	rewardType,
	onOpen,
}: {
	color: string;
	title: string;
	rewardId: string;
	rewardImageId: string;
	rewardType: RewardType;
	onOpen: () => void;
}) => {
	const reward = rage.cases.getRewardById(rewardId);
	const amount =
		rewardType === RewardType.EXP
			? (reward.value as ParseRewardValueTypeMap[RewardType.EXP]) ?? 0
			: rewardType === RewardType.MONEY
			? (reward.value as ParseRewardValueTypeMap[RewardType.MONEY]) ?? 0
			: 0;

	return (
		<StyledContainer>
			<StyledBg style={{ backgroundColor: color }} />
			<StyledPoint
				width="20"
				height="10"
				viewBox="0 0 20 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="20" height="10" rx="5" fill={color} />
				<rect
					x="0.5"
					y="0.5"
					width="19"
					height="9"
					rx="4.5"
					stroke="url(#paint0_linear_10111_2346)"
					strokeOpacity="0.5"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_10111_2346"
						x1="10"
						y1="0"
						x2="10"
						y2="10"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" stopOpacity="0" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
				</defs>
			</StyledPoint>
			<StyledTitle>{title}</StyledTitle>
			<StyledImageContainer>
				{rewardType === RewardType.VEHICLE && (
					<CollectionImage
						collection={'vehicles'}
						id={rewardImageId}
						size={'md'}
					/>
				)}
				{rewardType === RewardType.ITEM && isClothesItem(rewardImageId) && (
					<ClothesImage id={rewardImageId} size={56} />
				)}
				{rewardType === RewardType.ITEM && !isClothesItem(rewardImageId) && (
					<CollectionImage collection={'items'} id={rewardImageId} size={56} />
				)}
				{rewardType === RewardType.MONEY && (
					<img src={cardSoft} width={56} height={56} />
				)}
				{rewardType === RewardType.EXP && (
					<StyledExpContainer>
						<ImgIcon icon={star} width={24} height={24} color="#FFB500" />
						<Text style={{ fontSize: 16, fontWeight: 600 }}>
							{amount.toLocaleString('ru-RU')}
						</Text>
					</StyledExpContainer>
				)}
			</StyledImageContainer>
			<StyledButtonContainer>
				<Button
					onClick={onOpen}
					color={ButtonColors.Select}
					height={ButtonHeight.Height30}
				>
					<Text>Открыть кейс</Text>
				</Button>
			</StyledButtonContainer>
		</StyledContainer>
	);
};

export { CaseFeedItem };
